import React from 'react';
import { Box } from '@material-ui/core';
import {makeStyles, createStyles} from '@material-ui/core/styles';
import CarouselHOC from '../CarouselHOC';
import CourseOverlay from '@/components/02_molecules/CourseOverlay/CourseOverlay';

// To override/merge styles in CarouselHOC:
const useStyles = makeStyles((theme) => createStyles({
    rootCarousel: {
      '& .slick-track': {
        width: '64980px'
      },
      '& .slick-slide': {
        padding: 0,
        '& img': {
          height: '650px !important',
          [theme.breakpoints.down('xs')]: {
            height: '350px !important',
          },
        }
      },
      '& .slick-slider': {
        display: 'flex',
        alignItems: 'flex-end',
        [theme.breakpoints.down('sm')]: {
          padding: 0,
        },
      },
    },
    slickNext: {
      paddingTop: '1rem',
      right: '3rem',
      '& svg': {
        borderRadius: '4px',
      },
    },
    slickPrev: {
      paddingTop: '1rem',
      left: '3rem',

        '& svg': {
          borderRadius: '4px',
        },
    },
    slickArrow: {
      transform: 'none',
      display: 'flex',
      alignItems: 'center',
      fontFamily: 'Lato',
      '& svg': {
        width: '2.5rem',
        height: '2.5rem',
        color: '#3C8047',
        backgroundColor: '#fff',
        [theme.breakpoints.down('sm')]: {
          width: '2rem',
          height: '2rem',
        },
      },
    },
}));

const slickSettDefault = {
  slidesToShow: 1,
  slidesToScroll: 1,
  speed: 500,
  infinite: false,
};

function CourseCarousel(props) {
  if ((!props.slides || props.slides?.length < 1) && !props.children) {
    return null;
  }

  /* overlayData  -- will be positioned on top of all the slides as an overlay.
  *  overlay  --- has to be TRUE and "slides" attribute has to exist to display "overlayData"
  */
  let {slides, overlayData, showLight, showThumb, featured, slickSett, children, margin,
    marginUnit, linkOut, gutter, captions} = props;
  slickSett = slickSett || slickSettDefault;

  const HOCstyles = useStyles(props);

  return (
    <Box my={4} className="courseCarousel" position={`relative`}>
      <CarouselHOC courseCarousel classes={HOCstyles} slides={slides} featured={featured}
            slickSett={slickSett} showLight={showLight} overlay={overlayData ? true : undefined}
            showThumb={showThumb} margin={margin} marginUnit={marginUnit}
            linkOut={linkOut} gutter={gutter} captions={captions}>
        {/*{overlayData && slides?.length > 0 &&*/}
        {/*  <CourseOverlay node={overlayData} />*/}
        {/*}*/}
        {!overlayData && children}
      </CarouselHOC>
      {overlayData && slides?.length > 0 &&
      <CourseOverlay node={overlayData} />
      }
    </Box>
  );
}

export default CourseCarousel;
